import { render, staticRenderFns } from "./moneyDetailComponent.vue?vue&type=template&id=1477d504&scoped=true&"
import script from "./moneyDetailComponent.vue?vue&type=script&lang=js&"
export * from "./moneyDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./moneyDetailComponent.vue?vue&type=style&index=0&id=1477d504&scoped=true&lang=css&"
import style1 from "./moneyDetailComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477d504",
  null
  
)

export default component.exports